var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.7441C14.7806 17.7441 14.5651 17.6864 14.375 17.5769L3.12496 11.0803C2.52698 10.7349 2.3222 9.97015 2.6676 9.37216C2.7773 9.18224 2.93504 9.0245 3.12496 8.9148L14.375 2.4231C14.762 2.20093 15.2379 2.20093 15.625 2.4231L26.875 8.9148C27.473 9.2602 27.6777 10.025 27.3323 10.623C27.2226 10.8129 27.0649 10.9706 26.875 11.0803L15.625 17.5769C15.4349 17.6864 15.2194 17.7441 15 17.7441Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 13.9148L24.4198 12.4981L15.625 17.5769C15.2381 17.7999 14.7618 17.7999 14.375 17.5769L5.5801 12.4981L3.12496 13.9148C2.52698 14.2602 2.3222 15.025 2.6676 15.623C2.7773 15.8129 2.93504 15.9706 3.12496 16.0803L14.375 22.5769C14.7618 22.7999 15.2381 22.7999 15.625 22.5769L26.875 16.0803C27.473 15.7349 27.6777 14.9702 27.3323 14.3722C27.2226 14.1823 27.0649 14.0245 26.875 13.9148Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 18.9148L24.4198 17.4981L15.625 22.5769C15.2381 22.7999 14.7618 22.7999 14.375 22.5769L5.5801 17.4981L3.12496 18.9148C2.52698 19.2602 2.3222 20.025 2.6676 20.623C2.7773 20.8129 2.93504 20.9706 3.12496 21.0803L14.375 27.5769C14.7618 27.7999 15.2381 27.7999 15.625 27.5769L26.875 21.0803C27.473 20.7349 27.6777 19.9702 27.3323 19.3722C27.2226 19.1823 27.0649 19.0245 26.875 18.9148Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.3ebd64d642ee536579b69b046afbdd7b.svg";
export { ForwardRef as ReactComponent };